/**
 * The open editor, as the content sync driver sees it (PLAN.md "Client
 * engine", caller rule 2): before remote ops are applied to the open note,
 * its typing is flushed through `localEdit` in the same synchronous turn;
 * after the stored text changed, it reloads from the row.
 */

export interface OpenEditorHandle {
  /** Persists pending typing now, synchronously (no-op when nothing is pending). */
  flush(): void;
  /** The stored text moved ahead of the editor: reload from the row. */
  requestReload(): void;
}

const editors = new Map<string, OpenEditorHandle>();

export function registerOpenEditor(noteId: string, handle: OpenEditorHandle): () => void {
  editors.set(noteId, handle);
  return () => {
    if (editors.get(noteId) === handle) editors.delete(noteId);
  };
}

export function flushOpenEditor(noteId: string): void {
  editors.get(noteId)?.flush();
}

export function requestEditorReload(noteId: string): void {
  editors.get(noteId)?.requestReload();
}

/** Whether the note is open in an editor right now. */
export function hasOpenEditor(noteId: string): boolean {
  return editors.has(noteId);
}
